export default "__VITE_ASSET__COe1e6$___"